const microServices = {
  USER_SERVICE: "/user-service/api/super-admin",
};
export const endpoints = {
  SUPER_ADMIN_GATEWAY_NAME: `${microServices.USER_SERVICE}/campaign/sms/gateway-names`,
};
